var _effectorFileName = "/builds/gmini/front-utils/src/assertNever.ts";
import "core-js/modules/es.array.concat.js";
export function assertNever(name, x) {
  throw new Error("Unexpected ".concat(name, ": ").concat(JSON.stringify(x, null, '  ')));
}